import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  section: {
    '& + &': {
      marginTop: 32
    }
  },
  sectionTitle: {
    marginBottom: 12
  },
  sectionHint: {
    color: palette.shades[700],
    marginBottom: 12
  },
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 340,
    overflowY: 'auto',
    scrollbarGutter: 'stable'
  },
  fileRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '8px 12px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white
  },
  fileRowMain: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  fileWarning: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '8px 12px',
    borderRadius: 2,
    backgroundColor: palette.warning.light,
    '& .MuiTypography-root': {
      color: palette.warning.dark
    }
  },
  fileMeta: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    // Wide enough for the sort of name a provider's download gives a bill; the rest is the picker's.
    flex: '1 1 45%',
    minWidth: 0
  },
  fileMetaText: {
    minWidth: 0,
    '& .MuiTypography-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  fileSize: {
    color: palette.shades[700]
  },
  filePropertyField: {
    flex: '1 1 55%',
    minWidth: 0,
    /**
     * A chosen property takes the whole width of the field and the next one starts a line of its
     * own, so an address is read across rather than down. One longer than the line carries on to
     * the next line of the same tag instead of being cut short. The address is body text, so it is
     * set in the body font rather than the heavier one a chip is drawn in by default.
     */
    '& .MuiChip-root.MuiAutocomplete-tag': {
      width: '100%',
      maxWidth: '100%',
      margin: '3px 0',
      // Matches body2, which is what the file name beside it is set in.
      fontFamily: palette.fontFamilies.source,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '21px',
      '& + .MuiChip-root': {
        marginLeft: 0
      },
      '& .MuiChip-label': {
        flex: 1,
        minWidth: 0,
        whiteSpace: 'normal'
      }
    }
  },
  propertyItemText: {
    minWidth: 0,
    whiteSpace: 'normal'
  },
  propertyUtilities: {
    color: palette.shades[700]
  },
  emptyState: {
    padding: '16px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white,
    color: palette.shades[700],
    marginBottom: 12
  }
});
export default useStyles;